import * as React from "react";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {Dayjs} from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Box from "@mui/material/Box";
import clsx from "clsx";
import css from "./DateRange.module.css";
import 'dayjs/locale/pl';
import {DEF} from "../../const.ts";
// @ts-ignore
import ErrorInfo, {ErrorInfoState} from "../../Components/UI/Info/ErrorInfo.js";


interface DateRangeProps {
    dateFrom:       Dayjs;
    setDateFrom:    React.Dispatch<React.SetStateAction<Dayjs>>;
    dateTo:         Dayjs;
    setDateTo:      React.Dispatch<React.SetStateAction<Dayjs>>;
    setStatus:      React.Dispatch<React.SetStateAction<boolean>>;
}


export const DateRange: React.FC<DateRangeProps> = (props) => {
    const locale = 'pl';
    const [errorState, setErrorState] = React.useState(ErrorInfoState);
    const [dateFrom, setDateFrom] = React.useState<Dayjs | null>(props.dateFrom);
    const [dateTo, setDateTo] = React.useState<Dayjs | null>(props.dateTo);

    const handleDateFromChange = (newValue: Dayjs | null): boolean => {
        let result;
        if (!newValue) {
            setErrorState({
                ...errorState,
                msg: 'Data początkowa jest wymagana.',
                show: DEF.POPUP_SHOWING_INFINITE_TIME
            });
            result = false;
        } else if (newValue.isAfter(dateTo)) {
            setErrorState({
                ...errorState,
                msg: 'Próbujesz ustawić datę początku po dacie końcowej.',
                show: DEF.POPUP_SHOWING_INFINITE_TIME
            });
            result = false;
        } else {
            setErrorState({...errorState, msg: ''});
            props.setDateFrom(newValue);
            result = true;
        }
        return result;
    };


    const handleDateToChange = (newValue: Dayjs | null): boolean => {
        let result;
        if (!newValue) {
            setErrorState({
                ...errorState,
                msg: 'Data końcowa jest wymagana.',
                show: DEF.POPUP_SHOWING_INFINITE_TIME
            });
            result = false;
        } else if (newValue.isBefore(dateFrom)) {
            setErrorState({
                ...errorState,
                msg: 'Próbujesz ustawić datę końca okresu przed datą początkową.',
                show: DEF.POPUP_SHOWING_INFINITE_TIME
            });
            result = false;
        } else {
            setErrorState({...errorState, msg: ''});
            props.setDateTo(newValue);
            result = true;
        }
        return result;
    };


    const drawDatePicker = (): React.JSX.Element => {
        return  (
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
                <Box className={clsx(css.col)}>
                    <DatePicker
                        className={clsx(css.dateFrom, css.date)}
                        label="Data od"
                        format={DEF.DATE_FORMAT}
                        value={props.dateFrom}
                        onChange={(newValue) => {
                            setDateFrom(newValue);
                            handleDateFromChange(newValue);
                        }}
                        slotProps={{
                            textField: {}
                        }}
                    />

                    <DatePicker
                        className={clsx(css.dateTo, css.date)}
                        label="Data do"
                        format={DEF.DATE_FORMAT}
                        value={props.dateTo}
                        onChange={(newValue) => {
                            setDateTo(newValue);
                            handleDateToChange(newValue);
                        }}
                        slotProps={{
                            textField: {}
                        }}
                    />
                    {errorState.msg && <ErrorInfo state={errorState} setState={setErrorState}/>}
                </Box>
            </LocalizationProvider>
        )
    }

    return (
        <Box className={clsx(css.leadSearchDate, errorState && css.hasError)}>
            {drawDatePicker()}
        </Box>
    );

};
